import { generateEditUrl } from '../../core/utils/urlUtils';
import { formatLastEdited } from '../../core/utils/dateUtils';

/**
 * Get the current page based on the location pathname
 */
export const getCurrentPage = (pages, location, username, domain, version_slug) => {
  const currentPath = location.pathname;
  const currentPage = pages.find((page) => {
    const pageUrl = generateEditUrl(username, domain, version_slug, page.subdomain);
    return pageUrl === currentPath;
  });
  return currentPage || pages[0];
};

/**
 * Format a version slug to a readable version name
 */
export const formatVersionName = (versionSlug) => {
  if (!versionSlug) return "Unknown Version";
  const withoutDraft = versionSlug.replace(/^draft-/, "");
  return withoutDraft.split("-").map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(" ");
};

/**
 * Format a date as "last edited" time relative to user's timezone
 */
export const formatLastEditedTime = (updatedAt, timezone) => {
  return formatLastEdited(updatedAt, timezone);
};

